import { ROLE } from "./acl$"
import { CoordinatorService } from "./coordinator.service"

class GUser {

    constructor(private ug: UserGroup,
        public id: string,
        public name: string,
        public role: ROLE) {

    }
}

export class UserGroup {
    id: string
    title: string
    guLs: GUser[] = []

    constructor(public coords: CoordinatorService, public params: any) {
        console.log(params)
        this.id = params.id || params.groupId || this.coords.uniqueId()
        this.title = params.title
        this.updateUserLs(params.guLs)
    }

    get size() {
        return this.guLs.length
    }

    updateUserLs(guLs: any[]) {
        this.guLs = guLs.map(gu => new GUser(this, gu.id, gu.name, gu.role))
    }

    editDialog() {
        this.coords.display$.dialog$.next({
            action: `user-group`,
            grp: this
        })
    }

    async upload() {
        await this.coords.firebase$.callFunction("setUserGroup", this.cloudParams)
    }

    get cloudParams() {
        return {
            groupId: this.id,
            title: this.title,
            guLs: this.guLs.map(gu => ({
                id: gu.id,
                name: gu.name,
                role: gu.role
            }))
        }
    }

    get delParams() {
        return {
            icon: 'delete',

            fun: () => {
                this.delete()
            }
        }
    }

    async delete() {
        console.log("deleting user group", this.id)
        await this.coords.firebase$.callFunction("deleteUserGroup", {
            groupId: this.id
        })
        this.coords.user$.deleteUserGroup(this)
    }

    async inviteDialog() {
        this.coords.display$.dialog$.next({
            action:"team-group-invitation",
            grp: this
        })
    }
}
